var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25C2.41421 3.25 2.75 3.58579 2.75 4V11.2857C2.75 12.5284 3.75736 13.5357 5 13.5357H15.6944V8.57143C15.6944 8.26616 15.8795 7.99135 16.1623 7.87651C16.4452 7.76168 16.7694 7.82974 16.9822 8.04862L22.5377 13.7629C22.8208 14.054 22.8208 14.5174 22.5377 14.8085L16.9822 20.5228C16.7694 20.7417 16.4452 20.8097 16.1623 20.6949C15.8795 20.5801 15.6944 20.3053 15.6944 20V15.0357H5C2.92893 15.0357 1.25 13.3568 1.25 11.2857V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDownRight);
export default __webpack_public_path__ + "static/media/corner-down-right.7baef98c3e22f63009d0dadd3a63b23b.svg";
export { ForwardRef as ReactComponent };